import { useEffect, useState } from 'react';
import { listCustomRequests, updateCustomRequest } from '../../api/adminPackages';
import Button from '../../components/shared/ui/Button';

const AdminPackageRequests = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const load = async () => {
    setError('');
    try {
      const res = await listCustomRequests();
      setItems(res?.data || res || []);
    } catch (err) {
      setError(err.message || 'Failed to load requests');
    }
  };

  useEffect(() => {
    load();
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await updateCustomRequest(id, { status });
      await load();
    } catch (err) {
      setError(err.message || 'Status update failed');
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Tours & Packages</p>
        <h1 className="text-xl font-semibold text-slate-900">Custom Tour Requests</h1>
      </div>
      {error && <div className="rounded-2xl border border-rose-100 bg-rose-50 p-3 text-sm text-rose-700">{error}</div>}
      <div className="rounded-3xl border border-slate-200 bg-white p-4">
        <div className="overflow-auto">
          <table className="min-w-[720px] w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-[0.2em] text-slate-400">
                <th className="py-2">Traveler</th>
                <th className="py-2">Destination</th>
                <th className="py-2">Budget</th>
                <th className="py-2">Status</th>
                <th className="py-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.length ? (
                items.map((item) => (
                  <tr key={item.id} className="border-t border-slate-100">
                    <td className="py-3">
                      <div className="font-semibold text-slate-900">{item.name}</div>
                      <div className="text-xs text-slate-500">{item.email}</div>
                    </td>
                    <td className="py-3">{item.destination_text || item.destination_id || '-'}</td>
                    <td className="py-3">
                      {item.budget_min || '-'} - {item.budget_max || '-'}
                    </td>
                    <td className="py-3">{item.status}</td>
                    <td className="py-3 text-right">
                      <div className="flex justify-end gap-2">
                        <Button variant="outline" size="sm" onClick={() => updateStatus(item.id, 'in_progress')}>
                          In progress
                        </Button>
                        <Button variant="outline" size="sm" onClick={() => updateStatus(item.id, 'closed')}>
                          Close
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="py-6 text-center text-slate-500">
                    No custom tour requests yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminPackageRequests;
